import { useEffect } from 'react';
import { isEmpty, pull } from 'lodash/fp';
import Mousetrap from 'mousetrap';

delete window.Mousetrap;
const trapWithForm = new Mousetrap();
const trapNoForm = new Mousetrap();
const keyHandlerCache = [];

trapWithForm.stopCallback = () => false;
// overwrite default stopCallback implementation to handle esc key events on modals
trapNoForm.stopCallback = (e, element) =>
    element.tagName === 'INPUT' ||
    element.tagName === 'SELECT' ||
    element.tagName === 'TEXTAREA' ||
    (element.contentEditable && element.contentEditable === 'true') ||
    (element.hasAttribute && element.hasAttribute('data-nomousetrap'));

export function useMousetrap(key, handler, allowFormFields) {
    const trap = allowFormFields ? trapWithForm : trapNoForm;

    useEffect(() => {
        const keyHandlers = keyHandlerCache[key];
        if (isEmpty(keyHandlers)) {
            keyHandlerCache[key] = [handler];
        } else {
            keyHandlerCache[key] = [handler, ...keyHandlers];
        }

        trap.bind(key, handler);
        return () => {
            keyHandlerCache[key] = pull(handler)(keyHandlerCache[key]);
            trap.unbind(key);

            if (keyHandlerCache[key].length > 0) {
                trap.bind(key, keyHandlerCache[key][0]);
            }
        };
    }, [key, handler, trap]);
}
